module.exports = __webpack_public_path__ + "static/incography1-468ccb94315f046c8eb806a6c60b52cd.png";